module.exports = __webpack_public_path__ + "static/pmmrMob-53e4f122e94439242896e9c4f109a5e8.png";